module.exports = __webpack_public_path__ + "static/media/lightgrey.d33ffd98.png";